import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { addImage } from '../../actions/gallery';

const AddImage = ({addImage,auth}) => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        imgurl: '',
        imgtype: '',
        imgalt: ''
    })

    const {
        imgalt,
        imgurl,
        imgtype
    } = formData;

    const onChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = (e) => {
        e.preventDefault();
        addImage(formData, navigate);
    };
  
    return (
        <div className='container' style={{maxWidth: "650px"}}>
        <Card border="warning">
            <Card.Header>Add Images</Card.Header>
            <Card.Body>
                <form style={{ textAlign: "center" }} className="form" onSubmit={ e => onSubmit(e)}>

                    <label>Image Alt
                        <input type='text' placeholder='Image Alt' name="imgalt" value={imgalt} required onChange={e => onChange(e)} />
                    </label>

                    <label>Image Type
                        <select id="imgtype" name="imgtype" value={imgtype} size="1" required onChange={e => onChange(e)}>
                            <option value={'wide'}>wide</option>
                            <option value={'tall'}>tall</option>
                            <option value={'big'}>big</option>
                        </select>
                    </label>

                    <label>Image URL
                        <input type='text' placeholder='Image URL' name="imgurl" value={imgurl} required onChange={e => onChange(e)} />
                    </label>
                    <br />
                    <input type="submit" className="btn btn-success" value="Add Image" /> 
                </form>
            </Card.Body>
        </Card>
        </div>
    )
}

AddImage.propTypes = {
  addImage: propTypes.func.isRequired,
  auth: propTypes.object.isRequired,
  gallery: propTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gallery: state.gallery
});

export default connect(mapStateToProps, { addImage })(AddImage);